var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000152588,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4ECDC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3086 4.0295C7.37843 4.36607 4.25958 7.5441 4.01563 11.5H8.31978C8.48281 8.75259 9.53156 6.13122 11.3086 4.0295Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01562 12.5C4.25957 16.4559 7.37843 19.634 11.3086 19.9705C9.53156 17.8688 8.48281 15.2474 8.31978 12.5H4.01562Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6915 19.9706C16.6219 19.6342 19.7409 16.4561 19.9849 12.5H15.6803C15.5173 15.2475 14.4685 17.8688 12.6915 19.9706Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9849 11.5C19.7409 7.54396 16.6219 4.36584 12.6915 4.02946C14.4685 6.13119 15.5173 8.75258 15.6803 11.5H19.9849Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6784 11.5C14.5191 9.02722 13.5812 6.66811 12.0001 4.76134C10.4189 6.66811 9.48098 9.02722 9.32169 11.5H14.6784Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32169 12.5C9.48098 14.9728 10.4189 17.3319 12.0001 19.2387C13.5812 17.3319 14.5191 14.9728 14.6784 12.5H9.32169Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.4d6ae954c5c153f2281b084284b3c05c.svg";
export { ForwardRef as ReactComponent };